import React from "react";
import PropTypes from "prop-types";
const TableBordersIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd" transform="translate(1 1)">
      <path
        fill={color || "var(--color-easil-gray-x-dark)"}
        d="M6 2h2v2H6zM6 6h2v2H6zM10 6h2v2h-2zM2 6h2v2H2zM6 10h2v2H6z"
      />
      <rect
        width="14"
        height="14"
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        rx="2"
      />
    </g>
  </svg>
);
TableBordersIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default TableBordersIcon;
